import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentTrainingDurationService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-training-duration/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student credits list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student-training-duration/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById student credits", error);
            throw error;
        }
    },

    async save(student: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-training-duration/save`,
                student
            );
            return response.data;
        } catch (error) {
            console.error("Error save student credits", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/student-training-duration/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById student credits", error);
            throw error;
        }
    },

    async uploadStudentData(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-training-duration/upload-student-data`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save student credits", error);
            throw error;
        }
    },
}

export default studentTrainingDurationService;